var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top"},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Price")])]),_c('Widgets',{attrs:{"stats":_vm.priceStats}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }